import { VerifiedIcon } from '@THC/components/Icons/Verified';
import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import cypressIds from 'Components/cypress_ids.json';
import { IconTooltip } from 'Components/shared/IconTooltip';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { applyCypressData } from 'Utilities/helpers';

import { TradeDescription } from './TradeDescription/TradeDescription';
import { getTradeSellerStatsConfig } from './TradeSellerDetailsSection.helpers';
import LocalTexts from './TradeSellerDetailsSection.texts.json';

import styles from './TradeSellerDetailsSection.module.scss';

const LocalT = new MDText(LocalTexts);

export const TradeSellerDetailsSection: React.FC = () => {
	const {
		seller: { sellerStats },
	} = useVehicleData();
	const sellerStatsDisplayConfig = getTradeSellerStatsConfig(sellerStats);

	return (
		<>
			<div className={styles.description}>
				<IconTooltip
					content={LocalT.translate('verifiedBadgeTooltip')}
					icon={VerifiedIcon}
					side="bottom"
					triggerClassName={styles.tooltip}
				/>
				<span className={styles.descriptionText}>
					<TradeDescription />
				</span>
			</div>
			<div className={styles.stats}>
				{sellerStatsDisplayConfig.map(({ id, label, value }) => (
					<div key={id} className={styles.stat}>
						<span className={styles.value} {...applyCypressData(`${cypressIds.text.sellerStats}-stat-${id}`)}>
							{value}
						</span>
						<span className={styles.label} {...applyCypressData(`${cypressIds.text.sellerStats}-description-${id}`)}>
							{label}
						</span>
					</div>
				))}
			</div>
			<footer className={styles.promo}>
				<InfoBox content={LocalT.translate('promo')} size="small" variant="info" />
			</footer>
		</>
	);
};
